export default __webpack_public_path__ + "static/media/shyokriver.767ea85a.jpg";